import React, { useState } from 'react';
import { ClassFormInputs } from './form/ClassFormInputs';
import { SubmitButton } from './form/SubmitButton';
import { useClassFormState } from './form/useClassFormState';

interface ClassFormProps {
  onSubmit: (formData: {
    title: string;
    description: string;
    instructor: string;
    schedule: string;
    capacity: number;
    duration: number;
    gym_id?: string;
  }) => Promise<boolean>;
  initialData?: {
    title: string;
    description: string;
    instructor: string;
    schedule: string;
    capacity: number;
    duration: number;
  };
  isEditing?: boolean;
  gymId?: string;
}

export const ClassForm = ({ onSubmit, initialData, isEditing, gymId }: ClassFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const {
    title,
    setTitle,
    description,
    setDescription,
    instructor,
    setInstructor,
    schedule,
    setSchedule,
    capacity,
    setCapacity,
    duration,
    setDuration,
    profile
  } = useClassFormState(initialData);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Explicit validation for managers
    if (profile?.role === 'manager' && !instructor.trim()) {
      console.error("❌ Instructor is required for managers");
      return;
    }
    
    const formData = {
      title,
      description,
      instructor,
      schedule,
      capacity,
      duration,
      ...(gymId && { gym_id: gymId })
    };
    
    console.log("📤 Submitting form with data:", formData);
    console.log("📤 gymId passed to form:", gymId);
    console.log("📤 isEditing:", isEditing);
    
    setIsSubmitting(true);
    try {
      const success = await onSubmit(formData);
      console.log("✅ Submit result:", success);
    } catch (error) {
      console.error("❌ Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <ClassFormInputs
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        instructor={instructor}
        setInstructor={setInstructor}
        schedule={schedule}
        setSchedule={setSchedule}
        capacity={capacity}
        setCapacity={setCapacity}
        duration={duration}
        setDuration={setDuration}
        gymId={gymId}
        userRole={profile?.role}
      />
      <SubmitButton isEditing={isEditing} isSubmitting={isSubmitting} />
    </form>
  );
};